/* eslint-disable max-len */
import React, { Component } from 'react';
import { PaddedSection } from '../../atoms';
import './styles.css';
import { WebsiteCard } from '../../organisms';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Array<{ heading: string, href: string, logoSrc: string, previewSrc: string, subHeading: string, disabled?: boolean }>} [websiteCards]
 *
 * @augments {Component<Props>}
 */
export default class WebsiteCards extends Component {

	render () {
		const { websiteCards } = this.props;

		return (
			<PaddedSection className='WebsiteCards'>
				{websiteCards.map((card) => <WebsiteCard key={card.heading} {...card} />)}
			</PaddedSection>
		);
	}

}




// WEBPACK FOOTER //
// ./src/components/templates/WebsiteCards/WebsiteCards.js